export default __webpack_public_path__ + "static/media/rentacar_img_Seat_02.fee2d8dc.png";